import PropTypes from 'prop-types';
import { breadcrumbsPropTypes } from '@Theme/natucare/components/Breadcrumbs/BreadcrumbsPropTypes';
import { editorialTeamPropTypes } from './components/EditorialTeam/EditorialTeamPropTypes';
import { infoBarPropTypes } from './components/InfoBar/InfoBarPropTypes';
export const articleHeroPropTypes = {
  breadcrumbs: breadcrumbsPropTypes.items,
  heading: PropTypes.string,
  description: PropTypes.string,
  featuredImage: PropTypes.exact({
    src: PropTypes.string,
    alt: PropTypes.string
  }),
  editorialTeam: editorialTeamPropTypes.editorialTeam,
  ...infoBarPropTypes
};